__webpack_require__.p = "https://d31nhljklqe4s7.cloudfront.net/tamice_prod/";